<app-rc-dialog-wrapper noClose="true">
  <div class="confirmation-popin">
    <div class="image-confirmation">
      <img src="./assets/other/Group.png" alt="" />
    </div>

    <h3 class="rc-title-gamma confirmation-title">{{ 'Share-reco_pop-in_title-consultation-not-save' | translateKey }}</h3>

    <p class="rc-paragraph">
      {{
        (!isShowSendBackDataButton ? 'Share-reco_pop-in_description-save-consultation' : 'share-reco_pop-in_description-send-to-pms')
          | translateKey
      }}
    </p>

    <div class="rc-button-group">
      <rc-button
        data-qa="vs-prevent-exit-popin-button-save-consultation"
        (click)="!isShowSendBackDataButton ? save() : shareSendBackData()"
      >
        {{ (!isShowSendBackDataButton ? 'action_save-consultation' : 'sr_sendback_button') | translateKey }}
      </rc-button>
      <span class="rc-button__separator btn-separator" i18n="@@action_separator">or</span>
      <rc-link
        data-qa="vs-prevent-exit-popin-button-exit"
        variant="secundary"
        size="large"
        id="exit_without_saving_button"
        (click)="exitWithoutSave()"
      >
        {{ 'exit_without_saving_button' | translateKey }}
      </rc-link>
    </div>
  </div>
</app-rc-dialog-wrapper>
